import React from 'react';
import { withRouter } from 'react-router';

import AuthService from 'core/utils/auth/auth-service';
import HeaderLogo from './HeaderLogo';
import HeaderNav from './HeaderNav';
import HeaderUserSettings from './HeaderUserSettings';

class Header extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      dropdownOpen: false
    }

    this.toggleMobileNav = this.toggleMobileNav.bind(this)
    this.logout = this.logout.bind(this)
    this.to = this.to.bind(this)
    this.toggle = this.toggle.bind(this)
  }

  toggleMobileNav() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  logout(e) {
    e.preventDefault()
    AuthService.logout()
  }

  to(path) {
    const { history } = this.props;
    this.toggleMobileNav();
    history.push(path);
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    return (
      <div>
        <header className="Header">
          <div className="container">
            <div className="Header__wrapper">
              <HeaderLogo />
              <HeaderNav />
            </div>
            <HeaderUserSettings />
          </div>
        </header>
      </div>
    )
  }
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/components/layouts/LoggedIn/Header/Header.js